document.addEventListener('DOMContentLoaded', () => {
  const mediaBlocks = document.querySelectorAll('.blk-media .relative[data-autoplay]');

  /**
   * Plays the video within a given media block container.
   * Hides the image, overlay, and play button.
   *
   * @param {HTMLElement} container The media block's relative container element.
   */
  const playVideo = (container, isManualPlay = false) => {
    const playButton = container.querySelector('.blk-media-play');
    const videoSource = playButton?.dataset.source || container.dataset.source; // Get source from container too
    const videoType = playButton?.dataset.type || container.dataset.type; // Get type from container too
    const img = container.querySelector('img');
    const overlay = container.querySelector('.bg-opacity-60');
    const videoPlayer = container.querySelector('.blk-media-video');
    const iframe = container.querySelector('.blk-media-iframe');
    const shouldLoop = container.dataset.loop === 'true'; // Check loop attribute

    if (!videoSource) return; // No video source found

    // Hide elements
    if (playButton) playButton.style.display = 'none';
    if (img) img.style.display = 'none';
    if (overlay) overlay.style.display = 'none';

    if (videoType === 'file' && videoPlayer) {
        videoPlayer.style.display = 'block';
        // Unmute if manually played
        if (isManualPlay) {
            videoPlayer.muted = false;
        }
        // The 'loop' attribute is already set in PHP if needed
        videoPlayer.play().catch(error => console.error("Video play failed:", error)); // Play and catch errors
    } else if (videoType === 'url' && iframe) {
        let embedUrl = videoSource;
        let videoId = null;
        // Ensure autoplay=1 for YouTube/Vimeo
        const muteParam = isManualPlay ? 0 : 1; // Unmute if manually played
        if (videoSource.includes('youtu.be') || videoSource.includes('youtube.com')) {
            const videoIdMatch = videoSource.match(/youtu(?:\.be\/|be\.com\/(?:watch\?v=|v\/|embed\/|shorts\/|live\/)|(?:[\w-]+\.))([\w-]{11})(?:\?.*)?$/);
            if(videoIdMatch && videoIdMatch[1]) {
                videoId = videoIdMatch[1];
                embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=${muteParam}&playsinline=1`;
                if (shouldLoop) {
                  embedUrl += `&loop=1&playlist=${videoId}`; // YouTube requires playlist for loop
                }
            }
        } else if (videoSource.includes('vimeo.com')) {
             const videoIdMatch = videoSource.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-z0-9]+))?/);
             if (videoIdMatch && videoIdMatch[1]) {
                videoId = videoIdMatch[1];
                const privacyHash = videoIdMatch[2]; // Capture privacy hash if present
                embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=${muteParam}`;
                if (privacyHash) {
                  embedUrl += `&h=${privacyHash}`; // Add privacy hash as query parameter
                }
                if (shouldLoop) {
                  embedUrl += '&loop=1'; // Vimeo loop parameter
                }
             }
        }
        iframe.src = embedUrl;
        iframe.style.display = 'block';
    }
  };

  // --- Intersection Observer for Autoplay --- 
  const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0.5 // Trigger when 50% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const container = entry.target;
        const shouldAutoplay = container.dataset.autoplay === 'true';
        const playButton = container.querySelector('.blk-media-play'); // Check if play button exists

        // Only autoplay if the flag is true AND there is no play button OR the play button is hidden
        if (shouldAutoplay && (!playButton || playButton.style.display === 'none')) {
          // Play after 1 second delay
          setTimeout(() => {
            // Pass the container directly, as playVideo now handles getting source/type
            playVideo(container);
          }, 1000);

          // Stop observing once triggered
          observer.unobserve(container);
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // Observe each media block container
  mediaBlocks.forEach(block => {
    observer.observe(block);
  });

  // --- Manual Play Button Click Handler ---
  document.querySelectorAll('.blk-media-play').forEach(button => {
      button.addEventListener('click', (e) => {
          const container = e.currentTarget.closest('.relative[data-autoplay]');
          if (container) {
              playVideo(container, true); // Pass true for manual play (unmuted)
              // If manually clicked, ensure observer stops watching it
              observer.unobserve(container);
          }
      });
  });

}); 